import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";
const ReportUser = ({}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [api] = useServerApi();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.User.getReport();
      setLoading(false);

      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t("Please click the below button to download the user report.")}
      </Text>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportUser;
